import { featuresData } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-star-line text-sm"></i>
            </div>
            平台优势
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择玫瑰视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            91视频网站核心技术加持，为你打造极致的高清免费在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-5">
                <i className={`${feature.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}